module.exports = __webpack_public_path__ + "static/media/open-eye.a1ebee39.png";